import * as config from '@terraframing-suite/rx-config';
import { InputRow } from './InputRow';

export function PhosphorusPotassiumInstanceInputs({ type, inputs }) {
  const nutrient = type === 'P' ? 'phosphorus' : 'potassium';

  return (
    <>
      <InputRow
        name={`${type} Product`}
        value={
          inputs?.product &&
          config[nutrient].getProduct(inputs.product, inputs.percentage)
        }
      />
      <InputRow name={`${type} Groupings (lbs/ac)`} value={inputs?.group} />
      <InputRow name={`Other ${type} Applications`} value={inputs?.otherApps} />
      <InputRow name="Number of Cropping Years" value={inputs?.croppingYears} />
      <InputRow name="Years to Critical" value={inputs?.yearsToCriticalLevel} />
    </>
  );
}
